"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultModalContent = exports.defaultBannerContent = void 0;
const defaultBannerContent = exports.defaultBannerContent = {
  closeButton: {
    isDisplayed: false
  },
  textBanner: {
    en: '',
    zh: ''
  },
  button: {
    isDisplayed: false,
    text: {
      en: '',
      zh: ''
    }
  }
};
const defaultModalContent = exports.defaultModalContent = {
  modalTitle: {
    en: '',
    zh: ''
  },
  modalBody: {
    en: [''],
    zh: ['']
  },
  button: {
    isDisplayed: false,
    text: {
      en: '',
      zh: ''
    }
  }
};